require('../../modules/es6.string.includes');
module.exports = require('../../modules/_core').String.includes;



//////////////////
// WEBPACK FOOTER
// ../~/core-js/library/fn/string/includes.js
// module id = 313
// module chunks = 1